import type React from 'react';

interface SummarySectionProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}

const SummarySection: React.FC<SummarySectionProps> = ({
  icon,
  title,
  children,
}) => (
  <div>
    <div className="flex items-center min-h-[40px] gap-2 mt-8">
      {icon}
      <p className="font-medium my-auto">{title}</p>
    </div>
    {children}
  </div>
);

export default SummarySection;
